
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conventions",
      function () {
        return require("private-next-pages/conventions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conventions"])
      });
    }
  